import { useState, type ReactNode } from 'react';
import { MissingDataPeriodContext, type MissingDataPeriodScope } from '@/helpers/missingDataAlerts';

export default function MissingDataPeriodProvider({ children }: { children: ReactNode }) {
  const [scopes, setScopes] = useState<MissingDataPeriodScope[]>([]);
  return <MissingDataPeriodContext.Provider value={{ scopes, setScopes }}>{children}</MissingDataPeriodContext.Provider>;
}
